jQuery(function($){
  //alert('custom js');
  
  // Only For Mobile slider
  $('.announcement').slick({ 
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      mobileFirst: true,
      variableWidth: true,
        responsive: [
          {
             breakpoint: 767,
             settings: "unslick"
          }
       ]
    });
  
  // Only For Mobile slider
  $('.header-b>div').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: false,
      infinite: true,
      autoplaySpeed: 2000,
      mobileFirst: true,
        responsive: [
          {
             breakpoint: 767,
             settings: "unslick"
          }
       ]
    });

  
});


//Quick View
// function loadIframe(iframeName, url) {
//     var $iframe = $('#' + iframeName);
//     if ( $iframe.length ) {
//         $iframe.attr('src',url);   
//         return false;
//     }
//     return true;
// }
 